(()=>{'use strict';
function qty(root=document){root.querySelectorAll('[data-ura-cart-form]').forEach(form=>{
 if(form.dataset.uraQtyReady==='true')return;
 form.dataset.uraQtyReady='true';
 const inputs=Array.from(form.querySelectorAll('input[name="updates[]"]'));
 const express=form.querySelector('[data-ura-cart-express]');
 const note=form.querySelector('[data-ura-cart-pending-note]');
 function sync(){
  const dirty=inputs.some(input=>input.value!==input.defaultValue);
  if(express){express.hidden=dirty;express.inert=dirty;}
  if(note)note.hidden=!dirty;
 }
 form.addEventListener('input',sync);
 form.addEventListener('change',sync);
 form.addEventListener('reset',()=>setTimeout(sync,0));
 window.addEventListener('pageshow',sync);
 form.addEventListener('click',event=>{
  const plus=event.target.closest('[data-ura-cart-qty-plus]'),minus=event.target.closest('[data-ura-cart-qty-minus]');
  if(!plus&&!minus)return;
  const wrap=event.target.closest('.ura-cart-line__quantity'),input=wrap&&wrap.querySelector('input[type="number"]');
  if(!input)return;
  const now=Math.max(0,parseInt(input.value||'0',10)||0);
  input.value=String(plus?now+1:Math.max(0,now-1));
  input.dispatchEvent(new Event('change',{bubbles:true}));
 });
 sync();
})}
function accelerated(root=document){root.querySelectorAll('.ura-cart__express-host shopify-accelerated-checkout,.ura-cart__express-host shopify-accelerated-checkout-cart').forEach(el=>{const mobile=matchMedia('(max-width:680px)').matches;el.style.setProperty('--shopify-accelerated-checkout-button-block-size','44px');el.style.setProperty('--shopify-accelerated-checkout-button-inline-size','44px');el.style.setProperty('--shopify-accelerated-checkout-button-border-radius','3px');el.style.setProperty('--shopify-accelerated-checkout-button-box-shadow','none');el.style.setProperty('--shopify-accelerated-checkout-inline-alignment','center');el.style.setProperty('--shopify-accelerated-checkout-row-gap',mobile?'6px':'7px')})}
function watch(root=document){root.querySelectorAll('.ura-cart__express-host').forEach(host=>{if(host.dataset.uraExpressWatch==='true')return;host.dataset.uraExpressWatch='true';new MutationObserver(()=>accelerated(host)).observe(host,{childList:true,subtree:true})})}
function boot(root=document){qty(root);accelerated(root);watch(root)}
boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});document.addEventListener('shopify:section:load',event=>boot(event.target));window.addEventListener('pageshow',()=>boot());window.addEventListener('resize',()=>accelerated(),{passive:true});
})();
